import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import service from '../../Services/service';
import Select from 'react-select';
import { CreateUserPermission } from '../../Helper/PermissionHelper';

const modules = [
    { moduleId: 1, module: 'Layout' },
    { moduleId: 2, module: 'Screen' },
    { moduleId: 3, module: 'User' },
    { moduleId: 4, module: 'Campaign' },
    { moduleId: 5, module: 'Schedule' },
    {moduleId: 6, module: 'Content'},
    {moduleId: 7, module: 'Group'},
    {moduleId: 8, module: 'Permission'},
];
const permissionTypes = ['viewModule', 'createModule', 'editModule', 'deleteModule','shareModule'];

const CreatePermissionComponent = (props) => {
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");
    const [permissions, setPermissions] = useState({});

    useEffect(() => {
        fetchUsers();
        initializePermissions();
        if (props.id !== undefined) {
            setSelectedUser(props.id);
            fetchUserPermissions(props.id);
        }
    }, []);

    const fetchUsers = async () => {
        var userId = localStorage.getItem("userId")
        try {
            const response = await service.getdata('User/GetAll?sortBy=Name&sortDescending=false&pageNumber=1&pageSize=1000&userId=' + userId)
            if (response !== undefined) {
                setUsers(response.data.items);
            }
            //+ "&userId=" + userId

        } catch (error) {
            console.error('Error fetching users:', error);
            toast.error('Failed to fetch users.');
        }
    };

    const fetchUserPermissions = async (userId) => {
    try {
        const response = await service.getdata(`Permission/GetById?id=${userId}`);
        if (response) {
            const userPerms = response.data.lstmodule;

            // Start with default permissions
            const updatedPermissions = {};
            modules.forEach(mod => {
                updatedPermissions[mod.moduleId] = {
                    moduleId: mod.moduleId,
                    module: mod.module,
                    viewModule: false,
                    createModule: false,
                    editModule: false,
                    deleteModule: false,
                    shareModule: false,
                };
            });

            // Override with API data
            userPerms.forEach(p => {
                updatedPermissions[p.moduleId] = {
                    ...updatedPermissions[p.moduleId],
                    viewModule: p.viewModule || false,
                    createModule: p.createModule || false,
                    editModule: p.editModule || false,
                    deleteModule: p.deleteModule || false,
                    shareModule: p.shareModule || false,
                };
            });

            setPermissions(updatedPermissions);
        }
    } catch (error) {
        initializePermissions();
        console.error('Error fetching permission data:', error);
        toast.error('Failed to load user permission data.');
    }
};


    const handlePermissionChange = (moduleId, field) => {
        
        setPermissions(prev => {
            const updated = { ...prev };
            updated[moduleId] = {
                ...updated[moduleId],
                [field]: !updated[moduleId][field],
            };
            return updated;
        });
    };

    const initializePermissions = () => {
        const defaultPermissions = {};
        modules.forEach(mod => {
            defaultPermissions[mod.moduleId] = {
                moduleId: mod.moduleId,
                module: mod.module,
                viewModule: false,
                createModule: false,
                editModule: false,
                deleteModule: false,
                shareModule:false,
            };
        });
        setPermissions(defaultPermissions);
    };

    const userOptions = users.map((user) => ({
        value: user.userId,
        label: `${user.username} (${user.firstName} ${user.lastName})`,
    }));



    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!selectedUser) {
            toast.error("Please select a user first.");
            return;
        }

        const currentUserId = localStorage.getItem("userId");
        const payload = {
            permissionId: 0,
            userId: selectedUser,
            lstmodule: Object.values(permissions),
            createdBy: currentUserId,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
        };

        const res = await CreateUserPermission(payload);
        if (res !== undefined) {
            toast.success('Permission created successfully!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } else {
            toast.error('Failed to create permission. Please try again!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    return (
        <div className="container-fluid content-top-gap">
            <nav aria-label="breadcrumb" className="mb-4">
                <ol className="breadcrumb my-breadcrumb">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li class="breadcrumb-item active" aria-current="page">
                        {
                            props.id !== undefined ? 'Edit Permission' : 'Create Permission'
                        }
                    </li>
                </ol>
            </nav>

            <div className="row">
                <div className="col-lg-12 mb-4">
                    <div className="card card_border">
                        <div className="card-header chart-grid__header">{
                            props.id !== undefined ? 'Edit Permission' : 'Create Permission'
                        }</div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>

                                {/* User Dropdown */}
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-sm-2">
                                            <label><strong>Select User:</strong></label>
                                        </div>
                                        <div className="col-sm-10">
                                            <div className="col-sm-10">
                                                <Select
                                                    options={userOptions}
                                                    value={userOptions.find(option => option.value === Number(selectedUser))}
                                                    onChange={(option) => {
                                                        if (option) {
                                                            setSelectedUser(option.value);
                                                            fetchUserPermissions(option.value); // 🔄 fetch modules
                                                        } else {
                                                            setSelectedUser(null);
                                                            initializePermissions(); // 🔄 reset permissions if cleared
                                                        }
                                                    }}
                                                    placeholder="Search and select user"
                                                    isClearable={!props.id} // don't allow clearing if editing
                                                    isDisabled={props.id !== undefined}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Permissions Table */}
                                <div className="mt-4">
                                    <h5 className="mb-3 text-primary">Module Permissions</h5>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th style={{ width: '25%' }}>Module</th>
                                                    {permissionTypes.map((perm) => (
                                                        <th key={perm} className="text-center">{perm}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {modules.map((mod) => (
                                                    <tr key={mod.moduleId}>
                                                        <td><strong>{mod.module}</strong></td>
                                                        {permissionTypes.map(type => (
                                                            <td key={type} className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={permissions[mod.moduleId]?.[type] ?? false}
                                                                    onChange={() => handlePermissionChange(mod.moduleId, type)}
                                                                />
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <button type="submit" className="btn btn-success mt-3">Save</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreatePermissionComponent;
